<template>
  <div>
    <!-- Card -->
    <div class="bg-white border rounded-lg shadow p-4">
      <!-- Header -->
      <div class="flex justify-between items-center mb-4">
        <div class="text-xl font-bold text-primary">Device Type Summary</div>

        <!-- Export Button -->
        <button
          class="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
          @click="downloadCsv"
        >
          ⬇ Export CSV
        </button>
        <download-csv
          :data="exportData"
          name="device_type_summary.csv"
          class="hidden"
          ref="exportCsv"
        />
      </div>

      <!-- Chart -->
      <div class="px-2">
        <canvas id="device-type-graph" class="w-full h-64"></canvas>
      </div>

      <!-- Custom Legend Badges -->
      <div class="flex flex-wrap gap-2 mt-4">
        <span
          v-for="(label, index) in chartData.labels"
          :key="index"
          class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium text-white shadow"
          :style="{ backgroundColor: chartData.datasets[0].backgroundColor[index] }"
        >
          {{ label }}: {{ chartData.datasets[0].data[index] }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import moment from "moment";
import Chart from "chart.js";

export default {
  name: "DeviceTypeSummary",
  props: {
    filters: Object,
  },
  data() {
    return {
      chart: null,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Connections",
            data: [],
            backgroundColor: [
              "#2563eb",
              "#6b7280",
              "#10b981",
              "#f59e0b",
              "#9333ea",
              "#0d9488",
              "#518032",
              "#be185d",
              "#f97316",
            ],
          },
        ],
      },
      exportData: [],
    };
  },
  mounted() {
    this.initChart();
    this.loadStats();
  },
  watch: {
    filters: {
      handler() {
        this.loadStats();
      },
      deep: true,
    },
  },
  methods: {
    initChart() {
      const ctx = document.getElementById("device-type-graph");
      this.chart = new Chart(ctx, {
        type: "pie",
        data: this.chartData,
        options: {
          responsive: true,
          plugins: {
            legend: { display: false }, // hide default legend, use badges
            tooltip: {
              callbacks: {
                label: (tooltipItem) => {
                  let value =
                    this.chartData.datasets[0].data[tooltipItem.dataIndex] || 0;
                  let label = this.chartData.labels[tooltipItem.dataIndex] || "";
                  return `${label}: ${value.toLocaleString()}`;
                },
              },
            },
          },
        },
      });
    },
    loadStats() {
      let v = [];
      this.filters.venues.forEach((venue) => {
        v.push(venue.id);
      });

      let params =
        (this.filters.venues.length > 0
          ? 'venues:["' + v.join('","') + '"],'
          : "") +
        'groupBy: "is_mobile", startDate: "' +
        moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") +
        '", endDate: "' +
        moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") +
        '"';

      // Reset chart + export data
      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];
      this.exportData = [];

      GraphQl.sendRequest(
        "{aggregateDeviceSummary(" +
          params +
          "){connections is_mobile}}"
      ).then((response) => {
        response.aggregateDeviceSummary.forEach((stat) => {
          let label = stat.is_mobile ? "Mobile" : "Non Mobile";
          this.chartData.labels.push(label);
          this.chartData.datasets[0].data.push(stat.connections);
          this.exportData.push({
            "Device Type": label,
            Connections: stat.connections,
          });
        });

        this.chart.update();
      });
    },
    downloadCsv() {
      this.$refs.exportCsv.generate();
    },
  },
};
</script>

<style scoped>
</style>
